import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market,
} from '../market';

const SEO_GEO_AI_MONITORING_FAQ = [
  {
    title: 'Что такое мониторинг в AI-поисковиках?',
    isH3: true,
    text:
      <div>
        Мониторинг позиций в AI-поисковиках позволяет отслеживать, как ваш сайт рекомендуется AI-ассистентами.
        <br />
        <br />
        Вы узнаете:
        <br />
        <br />
        <ul>
          <li>на каких позициях упоминается ваш сайт</li>
          <li>какие запросы генерируют рекомендации с вашим сайтом</li>
          <li>динамику изменений за период</li>
        </ul>
      </div>
  },
  {
    title: 'Какие AI-платформы мониторятся?',
    isH3: true,
    text:
      <div>
        Сервис отслеживает позиции на следующих платформах:
        <br />
        <br />
        <ul>
          <li>ChatGPT / (OpenAI)</li>
          <li>Perplexity</li>
          <li>Claude / (Anthropic)</li>
          <li>Gemini / (Google)</li>
          <li>YandexGPT</li>
          <li>Яндекс Алиса</li>
          <li>DeepSeek</li>
        </ul>
      </div>
  },
];

const SEO_GEO_AI_PROMOTION_FAQ = [
  {
    title: 'Что такое продвижение через AI-поисковики?',
    isH3: true,
    text:
      <div>
        Продвижение через AI-платформы помогает улучшить поведенческие факторы (ПФ) для рекомендаций AI-ассистентов.
        <br />
        <br />
        Это включает:
        <br />
        <br />
        <ul>
          <li>переходы по рекомендациям AI</li>
          <li>изучение контента на рекомендованных сайтах</li>
          <li>взаимодействие с ответами и ссылками</li>
        </ul>
      </div>
  },
  {
    title: 'Какие AI-платформы поддерживаются?',
    isH3: true,
    text:
      <div>
        Сервис поддерживает следующие AI-платформы:
        <br />
        <br />
        <ul>
          <li>ChatGPT / (OpenAI)</li>
          <li>Perplexity</li>
          <li>Claude / (Anthropic)</li>
          <li>Gemini / (Google)</li>
          <li>YandexGPT</li>
          <li>Яндекс Алиса</li>
          <li>DeepSeek</li>
        </ul>
      </div>
  },
];

const STEP_TWO_TITLE_FAQ = <p>
  Почему при добавлении одного действия появляются дополнительные?
  <br />
  <br />
  Сервис формирует уникальные сценарии для каждого исполнителя.
</p>;

const MONITORING_ACTIONS = [
  { type: 'ALWAYS.OPEN', icon: 'open', title: 'Открыть AI-платформу', initialShare: 1 },
  { type: 'ALWAYS.LOGIN', icon: 'people', title: 'Авторизоваться', initialShare: 1 },
  { type: 'ALWAYS.ASK', icon: 'search', title: 'Задать вопрос', initialShare: 1 },
  { type: 'ALWAYS.WAIT_ANSWER', icon: 'time', title: 'Дождаться ответа', initialShare: 1 },
  { type: 'EXTRA.REPEAT', icon: 'action', title: 'Повторить запрос', initialShare: 1 },
  { type: 'MAIN.COPY_MONITOR', icon: 'copy', title: 'Скопировать ответ нейросети', initialShare: 1, activityType: 'Мониторинг' },
];

const PROMOTION_ACTIONS = [
  { type: 'ALWAYS.OPEN', icon: 'open', title: 'Открыть AI-платформу', initialShare: 1 },
  { type: 'ALWAYS.LOGIN', icon: 'people', title: 'Авторизоваться', initialShare: 1 },
  { type: 'ALWAYS.WRITE_PROMPT', icon: 'action', title: 'Сформулировать запрос', initialShare: 1 },
  { type: 'ALWAYS.SEND', icon: 'message', title: 'Отправить запрос', initialShare: 1 },
  { type: 'EXTRA.REPEAT', icon: 'action', title: 'Повторить запрос', initialShare: 1 },
  { type: 'MAIN.COPY_MENTION', icon: 'glasses', title: 'Проверить упоминание', initialShare: 1, activityType: 'Продвижение' },
];

const MAIN_PAGE_TITLES = [
  {
    iconHome: "home-eye",
    title: "Мониторинг",
    path: "/seo-geo-ai-monitoring",
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.NEW,
  },
  {
    iconHome: "home-click",
    title: "Продвижение",
    path: "/seo-geo-ai-promotion",
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.NEW,
  },
];

const STEP_PHRASE_2 = ' Укажите ключевые запросы и ссылку на сайт';

const SEO_GEO_AI_KEYWORDS = [
  'AI', 'ai', 'ChatGPT', 'Perplexity', 'Claude', 'Gemini', 
  'YandexGPT', 'Алиса', 'алиса', 'DeepSeek', 'нейросеть'
];

const MONITORING_PRICE = 10;
const PROMOTION_PRICE = 14;

// AI Agent configurations - matching backend platforms
const AI_AGENTS = [
  { id: 'all', title: 'Все платформы', description: 'Мониторинг/продвижение на всех AI-платформах' },
  { id: 'chatgpt', title: 'ChatGPT', description: 'AI-ассистент от OpenAI' },
  { id: 'alice', title: 'Яндекс Алиса', description: 'AI от Яндекс' },
  { id: 'gemini', title: 'Gemini', description: 'AI от Google' },
  { id: 'perplexity', title: 'Perplexity', description: 'AI-поисковик с цитированиями' },
  { id: 'deepseek', title: 'DeepSeek', description: 'Китайский AI-поисковик' },
];

class SeoGeoAiClass extends Market {

  id = 'seogeoai';

  host = null;
  url = null;

  title = 'AI Search';

  isMarketplace = false;
  isSeo = true;

  icon = "yandex";
  titlePlaces = 'AI-платформы';
  statusForHomePage = MARKET_MODE_STATUS.NEW;
  mainPageTitles = MAIN_PAGE_TITLES;

  chainsPerDayNormal = 42;

  chainPrice = PROMOTION_PRICE;
  chainsMin = 20;
  chainsMax = 1000;

  chainsDefault = 20;

  reviewPrice = 250;

  chainsStep = 10;
  viewsStep = 10;

  keywords = SEO_GEO_AI_KEYWORDS;

  targetLinkComment = 'Укажите тут адрес вашего сайта';
  targetLinkCommentShort = 'Укажите сайт';

  modes = [
    // Мониторинг
    {
      id: MARKET_MODES.CHAINS,
      path: '/seo-geo-ai-monitoring',
      rating: 0.01,
      title: 'Мониторинг',
      navigateTitle: 'Мониторинг позиций в AI-поисковиках',
      icon: "lightning",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Мониторинг позиций в AI от ${MONITORING_PRICE} руб. — ChatGPT, Perplexity, Claude`,
        description: 'Мониторинг позиций сайта в AI-поисковиках: ChatGPT, Perplexity, Claude, Gemini, YandexGPT, Алиса, DeepSeek.',
        canonical: '/seo-geo-ai-monitoring',
      },
      intro: {
        title: 'AI Search: Мониторинг ↑',
        comment: 'Отслеживайте позиции вашего сайта в AI-поисковиках:',
        points: [
          'Мониторинг позиций в ChatGPT',
          'Мониторинг в Perplexity, Claude, Gemini',
          'Мониторинг в YandexGPT и Алисе',
          'Мониторинг в DeepSeek',
        ]
      },
      howItWorks: [
        'Выберите AI-агента для мониторинга',
        'Укажите ключевые запросы',
        'Получайте регулярные отчеты о позициях',
        'Отслеживайте динамику изменений'
      ],
      stepPhrase1: 'Выберите AI-агента для мониторинга',
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Мониторинг ответов в AI',
      titleFAQ: "Вопрос-ответ о мониторинге в AI",
      faq: SEO_GEO_AI_MONITORING_FAQ,
      actions: MONITORING_ACTIONS,
      notice: [
        '* Выберите нужный AI-агент на первом шаге',
        'Мониторинг проводится регулярно',
        'Вы получаете отчеты о позициях',
      ]
    },
    // Продвижение
    {
      id: MARKET_MODES.CHAINS,
      path: '/seo-geo-ai-promotion',
      rating: 0.01,
      title: 'Продвижение',
      navigateTitle: 'Продвижение через AI-поисковики',
      icon: "lightning",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Продвижение через AI-поисковики от ${PROMOTION_PRICE} руб. — ChatGPT, Perplexity, Claude`,
        description: 'Поведенческие факторы через AI: ChatGPT, Perplexity, Claude, Gemini, YandexGPT, Алиса, DeepSeek.',
        canonical: '/seo-geo-ai-promotion',
      },
      intro: {
        title: 'AI Search: Продвижение ↑',
        comment: 'Протестируйте продвижение через AI-платформы:',
        points: [
          'Поведенческие факторы (ПФ) для AI',
          'Переходы по рекомендациям AI',
          'Повышение вовлеченности',
          'Поддержка: ChatGPT, Perplexity, Claude, Gemini, YandexGPT, Алиса, DeepSeek',
        ]
      },
      howItWorks: [
        'Выберите AI-агента для продвижения',
        'Настройте параметры активности',
        'Укажите фразы для поиска',
        'После оплаты получите отчет'
      ],
      stepPhrase1: 'Выберите AI-агента и настройте параметры',
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Продвижение через AI',
      titleFAQ: "Вопрос-ответ о продвижении через AI",
      faq: SEO_GEO_AI_PROMOTION_FAQ,
      actions: PROMOTION_ACTIONS,
      notice: [
        '* Выберите нужный AI-агент на первом шаге',
        'Каждый исполнитель получит индивидуальное задание',
        'Поддерживаемые платформы: ChatGPT, Perplexity, Claude, Gemini, YandexGPT, Яндекс Алиса, DeepSeek',
      ]
    },
  ];

  // AI Agents for selection in calculator
  aiAgents = AI_AGENTS;

  actionsMap = [...MONITORING_ACTIONS, ...PROMOTION_ACTIONS].reduce((map, action) => {
    map[action.type] = action; return map;
  }, {});

  emptyUrlStr = 'Введите вопрос';
  invalidUrlStr = 'Введите корректный вопрос';
}

const SeoGeoAi = new SeoGeoAiClass();
export default SeoGeoAi;
